import React, { useCallback, useState } from "react";

import { useDispatch } from "react-redux";

import { SideLoadedDataSetAction } from "actions/sideLoadedData";

import { Button, SecondaryButton } from "components/Form";
import { StyledInput } from "components/Form/FormikControls/layout";
import { Column, Row } from "components/Layout";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  ZoomyDialog,
} from "components/MaterialDialog";
import { SmallText } from "components/Text";

interface RenameDataSetModalProps {
  dataSet: SideLoadedDataSet;
  onClose: () => void;
}

export function RenameDataSetModal({
  dataSet,
  onClose,
}: RenameDataSetModalProps): React.JSX.Element {
  const dispatch = useDispatch();
  const [name, setName] = useState(dataSet.name);

  const onSave = useCallback(() => {
    if (name.trim() && name.trim() !== dataSet.name) {
      dispatch(
        SideLoadedDataSetAction.update({ id: dataSet.id, name: name.trim() }),
      );
    }
    onClose();
  }, [dispatch, dataSet.id, dataSet.name, name, onClose]);

  return (
    <ZoomyDialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle onClose={onClose}>Rename Data Set</DialogTitle>

      <DialogContent dividers>
        <Column>
          <Row paddingVertical={2}>
            <SmallText>
              The name came from the uploaded file. Renaming affects this data
              set only - its records and column template are untouched.
            </SmallText>
          </Row>
          <StyledInput
            value={name}
            onChange={event => setName(event.target.value)}
            placeholder="Name this data set"
          />
        </Column>
      </DialogContent>

      <DialogActions>
        <SecondaryButton type="button" onClick={onClose}>
          Cancel
        </SecondaryButton>
        <Button type="button" onClick={onSave} disabled={!name.trim()}>
          Save
        </Button>
      </DialogActions>
    </ZoomyDialog>
  );
}
